export const FETCH_CITY_WEATHER = 'FETCH_CITY_WEATHER'
export const FETCH_CITY_WEATHER_SUCCESS = 'FETCH_CITY_WEATHER_SUCCESS'
export const FETCH_CITY_WEATHER_FAILURE = 'FETCH_CITY_WEATHER_FAILURE'

export const FETCH_CITIES_AC = 'FETCH_CITIES_AC'
export const FETCH_CITIES_AC_SUCCESS = 'FETCH_CITIES_AC_SUCCESS'
export const FETCH_CITIES_AC_FAILURE = 'FETCH_CITIES_AC_FAILURE'
export const RESET_CITIES_AC = 'RESET_CITIES_AC'

export const ADD_TO_FAVORITES = 'ADD_TO_FAVORITES'
export const REMOVE_FROM_FAVORITES = 'REMOVE_FROM_FAVORITES'

export const SET_FAVORITE_TO_CITY_WEATHER = 'SET_FAVORITE_TO_CITY_WEATHER'

export const SET_FAHRENHEIT = 'SET_FAHRENHEIT'
export const SET_CELSIUS = 'SET_CELSIUS'

export const SET_DARK_MODE = 'SET_DARK_MODE'
export const SET_LIGHT_MODE = 'SET_LIGHT_MODE'


